/* Innerbloom Reverse-Age Body Oil — PDP behaviour: gallery, bundle picker, AJAX cart drawer with upsell, sticky bar, reviews. */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents, currency) {
    var value = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: currency || 'GBP',
        minimumFractionDigits: value % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }).format(value);
    } catch (e) {
      return '£' + value.toFixed(2);
    }
  }

  function postJSON(url, body) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  }

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  /* ---------- Menu ---------- */
  function initMenu() {
    var menu = $('[data-ib-menu]');
    if (!menu) return;
    function set(open) {
      menu.classList.toggle('is-open', open);
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.classList.toggle('ib-lock', open);
    }
    $$('[data-ib-menu-open]').forEach(function (b) { b.addEventListener('click', function () { set(true); }); });
    $$('[data-ib-menu-close]', menu).forEach(function (b) { b.addEventListener('click', function () { set(false); }); });
    $$('a', menu).forEach(function (a) { a.addEventListener('click', function () { set(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
  }

  /* ---------- Announcement bar ---------- */
  function initAnnounce() {
    var msgs = $$('.ib-announce__msg');
    if (msgs.length < 2) return;
    var i = 0;
    window.setInterval(function () {
      var cur = msgs[i];
      i = (i + 1) % msgs.length;
      cur.classList.add('is-leaving');
      cur.classList.remove('is-active');
      cur.setAttribute('aria-hidden', 'true');
      msgs[i].classList.remove('is-leaving');
      msgs[i].classList.add('is-active');
      msgs[i].removeAttribute('aria-hidden');
      window.setTimeout(function () { cur.classList.remove('is-leaving'); }, 600);
    }, 4200);
  }

  /* ---------- Header: scrolled state, jump bar, scrollspy ---------- */
  function initHeader() {
    var header = $('[data-ib-header]');
    if (!header) return;
    var jump = $('[data-ib-jump]', header);
    var buy = document.getElementById('ib-product-form') || document.getElementById('ib-buy');
    var links = jump ? $$('.ib-jump__link', jump) : [];
    var targets = [];
    links.forEach(function (a) {
      var id = (a.getAttribute('href') || '').replace('#', '');
      var el = id && document.getElementById(id);
      if (!el) { a.hidden = true; return; }
      targets.push({ a: a, el: el });
    });
    var active = null;
    function onScroll() {
      var y = window.scrollY || window.pageYOffset;
      header.classList.toggle('is-scrolled', y > 8);
      if (jump && buy) {
        var past = buy.getBoundingClientRect().bottom < 0;
        header.classList.toggle('has-jump', past && targets.length > 0);
      }
      if (!targets.length) return;
      var line = 140, current = null;
      targets.forEach(function (t) { if (t.el.getBoundingClientRect().top <= line) current = t; });
      if (current !== active) {
        if (active) active.a.classList.remove('is-active');
        active = current;
        if (active) {
          active.a.classList.add('is-active');
          var track = active.a.parentNode;
          track.scrollTo({ left: active.a.offsetLeft - 16, behavior: 'smooth' });
        }
      }
    }
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { onScroll(); ticking = false; });
    }, { passive: true });
    onScroll();
  }

  /* ---------- Clinicians' Choice card ---------- */
  function initClinic() {
    var cc = $('[data-ib-cc]');
    if (!cc) return;
    var key = 'ib-cc-hidden';
    try { if (window.sessionStorage.getItem(key)) cc.hidden = true; } catch (e) {}
    var btn = $('[data-ib-cc-close]', cc);
    if (btn) btn.addEventListener('click', function (e) {
      e.preventDefault();
      cc.classList.add('is-hidden');
      window.setTimeout(function () { cc.hidden = true; }, 300);
      try { window.sessionStorage.setItem(key, '1'); } catch (err) {}
    });
  }

  /* ---------- Gallery ---------- */
  function initGallery() {
    var track = $('[data-ib-gallery-track]');
    if (!track) return;
    var thumbs = $$('[data-ib-thumb]');
    var slides = $$('[data-ib-slide]', track);
    var current = 0;

    function go(i) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[current].offsetLeft, behavior: 'smooth' });
    }
    function mark(i) {
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
      var active = thumbs[i];
      if (active && active.parentNode) {
        var p = active.parentNode;
        p.scrollTo({ left: active.offsetLeft - p.clientWidth / 2 + active.clientWidth / 2, behavior: 'smooth' });
      }
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-ib-thumb'), 10)); });
    });
    var prev = $('[data-ib-gallery-prev]');
    var next = $('[data-ib-gallery-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });

    var count = $('[data-ib-count]');
    // Arrows and the counter are hidden on load, appear on scroll, touch or hover, and fade out again after 2.5 s.
    var main = track.parentNode, idleTimer;
    function wake() {
      main.classList.remove('is-idle');
      window.clearTimeout(idleTimer);
      idleTimer = window.setTimeout(function () { main.classList.add('is-idle'); }, 2500);
    }
    ['pointerdown', 'pointermove', 'focusin'].forEach(function (ev) { main.addEventListener(ev, wake, { passive: true }); });
    track.addEventListener('scroll', wake, { passive: true });
    // Start hidden: arrows and counter only appear once someone touches, hovers or swipes the gallery.
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) { current = i; }
        mark(current);
        if (count) count.textContent = current + 1;
        ticking = false;
      });
    }, { passive: true });

    track.setAttribute('tabindex', '0');
    track.setAttribute('aria-label', 'Product images, use the arrow keys to browse');
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    });
  }

  /* ---------- Card carousels (results, videos, oils, before/after) ---------- */
  function initCarousels() {
    $$('[data-ib-carousel]').forEach(function (wrap) {
      var track = $('[data-ib-track]', wrap);
      if (!track) return;
      var prev = $('[data-ib-prev]', wrap);
      var next = $('[data-ib-next]', wrap);
      var bar = $('[data-ib-bar]', wrap);

      function cards() {
        return Array.prototype.filter.call(track.children, function (c) { return c.offsetWidth > 0; });
      }
      function step() {
        var list = cards();
        if (list.length < 2) return track.clientWidth;
        var one = list[1].offsetLeft - list[0].offsetLeft;
        var perView = Math.max(1, Math.floor((track.clientWidth + 1) / one));
        return one * perView;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        var scrollable = max > 4;
        wrap.classList.toggle('is-static', !scrollable);
        if (!scrollable) return;
        var x = track.scrollLeft;
        if (prev) prev.disabled = x <= 4;
        if (next) next.disabled = x >= max - 4;
        if (bar) {
          var w = Math.max(12, Math.min(100, (track.clientWidth / track.scrollWidth) * 100));
          bar.style.width = w + '%';
          bar.style.transform = 'translateX(' + ((x / max) * (100 - w) / w * 100) + '%)';
        }
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { update(); ticking = false; });
      }, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      else window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Selling-out timer (UK time) ---------- */
  function initUrgency() {
    var el = $('[data-ib-urgency]');
    if (!el) return;
    var out = $('[data-ib-timer]', el);
    var box = out && out.parentNode;
    var mode = el.getAttribute('data-mode');
    if (!out || mode === 'none') return;

    var fmt;
    try {
      fmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
    } catch (e) { return; }

    // The UK wall-clock time as a UTC timestamp, so date maths works in London time.
    function londonNow() {
      var p = {};
      fmt.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      return Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second);
    }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function clock(ms) {
      var t = Math.max(0, Math.floor(ms / 1000));
      var d = Math.floor(t / 86400); t -= d * 86400;
      var h = Math.floor(t / 3600); t -= h * 3600;
      var m = Math.floor(t / 60); var sec = t - m * 60;
      return (d ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
    }
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    function target(now) {
      if (mode === 'end') {
        var m = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?/.exec(el.getAttribute('data-end') || '');
        if (!m) return null;
        return { at: Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 23), +(m[5] || 59), m[4] ? 0 : 59), label: el.getAttribute('data-label-end'), day: '' };
      }
      var cutoff = parseInt(el.getAttribute('data-cutoff'), 10) || 14;
      var today = new Date(now);
      for (var i = 0; i < 8; i++) {
        var d = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate() + i, cutoff, 0, 0));
        var wd = d.getUTCDay();
        if (wd === 0 || wd === 6 || d.getTime() <= now) continue;
        var word = i === 0 ? 'today' : (i === 1 ? 'tomorrow' : 'on ' + days[wd]);
        return { at: d.getTime(), label: el.getAttribute('data-label-dispatch'), day: word };
      }
      return null;
    }

    function tick() {
      var now = londonNow();
      var t = target(now);
      if (!t || t.at <= now) { box.hidden = true; return; }
      var parts = (t.label || '[time]').split('[time]');
      out.innerHTML = esc(parts[0]).replace('[day]', esc(t.day)) + '<strong>' + clock(t.at - now) + '</strong>' + esc(parts.slice(1).join('')).replace('[day]', esc(t.day));
      box.hidden = false;
    }
    tick();
    window.setInterval(tick, 1000);
  }

  /* ---------- Bundle picker + add to basket ---------- */
  function initBuyBox() {
    var form = document.getElementById('ib-product-form');
    if (!form) return;
    var input = $('[data-ib-variant-input]', form);
    var offers = $$('[data-ib-offer]', form);
    var atcBtn = $('[data-ib-atc]', form);
    var atcPrice = $('[data-ib-atc-price]', form);
    var errorEl = $('[data-ib-form-error]', form);
    var stickyPrice = $('[data-ib-sticky-price]');
    var stickyOffer = $('[data-ib-sticky-offer]');

    function select(offer) {
      if (!offer) return;
      var radio = $('input[type="radio"]', offer);
      if (radio && radio.disabled) return;
      offers.forEach(function (o) {
        var on = o === offer;
        o.classList.toggle('is-selected', on);
        var r = $('input[type="radio"]', o);
        if (r) r.checked = on;
      });
      input.value = offer.getAttribute('data-variant-id');
      if (atcPrice) atcPrice.textContent = offer.getAttribute('data-price');
      if (stickyPrice) stickyPrice.textContent = offer.getAttribute('data-price');
      if (stickyOffer) stickyOffer.textContent = offer.getAttribute('data-offer-title');
    }

    offers.forEach(function (o) {
      o.addEventListener('click', function (e) { e.preventDefault(); select(o); });
      o.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(o); }
      });
      o.setAttribute('tabindex', '0');
    });

    $$('[data-ib-choose-offer]').forEach(function (link) {
      link.addEventListener('click', function () {
        var n = parseInt(link.getAttribute('data-ib-choose-offer'), 10) - 1;
        if (offers[n]) select(offers[n]);
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (errorEl) errorEl.hidden = true;
      atcBtn.disabled = true;
      postJSON('cart/add.js', { items: [{ id: parseInt(input.value, 10), quantity: 1 }] })
        .then(function () { return Drawer.refresh(); })
        .then(function () { Drawer.open(); })
        .catch(function (err) {
          if (errorEl) {
            errorEl.textContent = (err && (err.description || err.message)) || 'Something went wrong. Please try again.';
            errorEl.hidden = false;
          }
        })
        .then(function () { atcBtn.disabled = false; });
    });

    /* Sticky bar */
    var sticky = $('[data-ib-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var below = entry.boundingClientRect.top < 0;
          var show = !entry.isIntersecting && below;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          var btn = $('[data-ib-sticky-btn]', sticky);
          if (btn) btn.tabIndex = show ? 0 : -1;
        });
      });
      io.observe(atcBtn);
      var sBtn = $('[data-ib-sticky-btn]', sticky);
      if (sBtn) sBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else atcBtn.click();
      });
    }
  }

  /* ---------- Cart drawer ---------- */
  var Drawer = {
    el: null,
    open: function () {
      if (!this.el) return;
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ib-lock');
      var close = $('[data-ib-cart-close].ib-iconbtn', this.el);
      if (close) close.focus();
    },
    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ib-lock');
    },
    refresh: function () {
      var self = this;
      return getCart().then(function (cart) { self.render(cart); return cart; });
    },
    render: function (cart) {
      var el = this.el;
      $$('[data-ib-cart-count]').forEach(function (c) {
        c.textContent = cart.item_count;
        c.hidden = cart.item_count === 0;
      });
      if (!el) return;
      var singleId = parseInt(el.getAttribute('data-single-id'), 10);
      var bundleId = parseInt(el.getAttribute('data-bundle-id'), 10);
      var hasBundle = cart.items.some(function (i) { return i.variant_id === bundleId; });
      var hasSingle = cart.items.some(function (i) { return i.variant_id === singleId; });
      var empty = cart.item_count === 0;

      $('[data-ib-drawer-count]', el).textContent = cart.item_count;

      var text = empty ? el.getAttribute('data-progress-empty') : (hasBundle ? el.getAttribute('data-progress-bundle') : el.getAttribute('data-progress-single'));
      $('[data-ib-progress-text]', el).textContent = text;
      $('[data-ib-progress-fill]', el).style.width = hasBundle ? '100%' : (hasSingle ? '34%' : '0%');
      $$('[data-ib-milestone]', el).forEach(function (m) { m.classList.toggle('is-done', hasBundle); });

      var compare = el.getAttribute('data-bundle-compare');
      $('[data-ib-lines]', el).innerHTML = cart.items.map(function (item) {
        var isBundle = item.variant_id === bundleId;
        var img = item.image ? '<img src="' + esc(item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2')) + '" alt="" loading="lazy">' : '';
        var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        return '<div class="ib-line" data-key="' + esc(item.key) + '">' +
          '<div class="ib-line__img">' + img + '</div>' +
          '<div class="ib-line__info">' +
            '<div class="ib-line__title">' + esc(item.product_title) + '</div>' +
            (variant ? '<div class="ib-line__variant">' + esc(variant) + '</div>' : '') +
            '<div class="ib-line__row">' +
              '<div class="ib-qty">' +
                '<button type="button" data-ib-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-ib-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<div>' + (isBundle && compare ? '<span class="ib-line__compare">' + esc(compare) + '</span>' : '') +
                '<span class="ib-line__price">' + money(item.final_line_price, cart.currency) + '</span></div>' +
            '</div>' +
          '</div>' +
        '</div>';
      }).join('');

      $('[data-ib-gifts]', el).hidden = !hasBundle;
      $('[data-ib-upsell]', el).hidden = !(hasSingle && !hasBundle);
      $('[data-ib-empty]', el).hidden = !empty;
      $('[data-ib-foot]', el).hidden = empty;
      var saveRow = $('[data-ib-save-row]', el); if (saveRow) saveRow.hidden = !hasBundle;

      $('[data-ib-subtotal]', el).textContent = money(cart.items_subtotal_price, cart.currency);
      $('[data-ib-delivery]', el).textContent = hasBundle ? el.getAttribute('data-delivery-bundle') : el.getAttribute('data-delivery-single');
      $('[data-ib-total]', el).textContent = money(cart.total_price, cart.currency);
    },
    init: function () {
      var self = this;
      this.el = $('[data-ib-drawer]');
      $$('[data-ib-cart-open]').forEach(function (b) {
        b.addEventListener('click', function () { self.refresh().then(function () { self.open(); }); });
      });
      if (!this.el) return;
      $$('[data-ib-cart-close]', this.el).forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });

      this.el.addEventListener('click', function (e) {
        var qtyBtn = e.target.closest('[data-ib-qty]');
        if (qtyBtn) {
          var line = qtyBtn.closest('[data-key]');
          var q = Math.max(0, parseInt(qtyBtn.getAttribute('data-ib-qty'), 10));
          qtyBtn.disabled = true;
          postJSON('cart/change.js', { id: line.getAttribute('data-key'), quantity: q }).then(function (cart) { self.render(cart); });
          return;
        }
        var up = e.target.closest('[data-ib-upgrade]');
        if (up) {
          var singleId = self.el.getAttribute('data-single-id');
          var bundleId = self.el.getAttribute('data-bundle-id');
          up.disabled = true;
          getCart().then(function (cart) {
            var bundleQty = 0;
            cart.items.forEach(function (i) { if (String(i.variant_id) === bundleId) bundleQty += i.quantity; });
            var updates = {};
            updates[singleId] = 0;
            updates[bundleId] = bundleQty + 1;
            return postJSON('cart/update.js', { updates: updates });
          }).then(function (cart) { self.render(cart); }).catch(function () {}).then(function () { up.disabled = false; });
        }
      });
      this.refresh();
    }
  };

  /* ---------- UGC videos ---------- */
  function initUgc() {
    $$('[data-ib-ugc]').forEach(function (card) {
      var btn = $('[data-ib-ugc-play]', card);
      var video = $('video', card);
      if (!btn || !video) return;
      btn.addEventListener('click', function () {
        video.muted = false;
        video.controls = true;
        video.play();
        card.classList.add('is-playing');
      });
    });
  }

  /* ---------- Review wall ---------- */
  function initReviews() {
    var wall = $('[data-ib-wall]');
    if (!wall) return;
    var reviews = $$('[data-ib-review]', wall);
    var moreBtn = $('[data-ib-more-btn]');
    var filters = $$('[data-ib-filter]');

    filters.forEach(function (f) {
      f.addEventListener('click', function () {
        var key = f.getAttribute('data-ib-filter');
        filters.forEach(function (x) { x.classList.toggle('is-active', x === f); });
        reviews.forEach(function (r) {
          var tags = (r.getAttribute('data-tags') || '').split(' ');
          r.hidden = !(key === 'all' || tags.indexOf(key) !== -1);
        });
        if (moreBtn) moreBtn.hidden = true;
      });
    });

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        var hidden = reviews.filter(function (r) { return r.hasAttribute('data-ib-more') && r.hidden; });
        hidden.slice(0, 8).forEach(function (r) { r.hidden = false; });
        if (hidden.length <= 8) moreBtn.hidden = true;
      });
    }
  }

  function init() {
    initMenu();
    initAnnounce();
    initHeader();
    initClinic();
    initGallery();
    initCarousels();
    initBuyBox();
    initUrgency();
    Drawer.init();
    initUgc();
    initReviews();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
